<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.user_segment_list') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" size="sm" class="ml-1" variant="success">{{ $t('btn.add_new') }}</b-button>
      </template>
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="name"
                  :label="$t('filters.label.question_list_phrase')"
                  :placeholder="$t('filters.placeholder.question_list_phrase')">
              </filter-input>
            </div>

            <div class="col-4">
              <filter-select
                  :filter-query="filterQuery"
                  :options="selectOptions.isStatic"
                  :multiple="false"
                  options-label="text"
                  options-track-by="value"
                  filter-name="isStatic"
                  :label="$t('filters.label.type')"
                  :placeholder="$t('filters.placeholder.type')">
              </filter-select>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{ $t('filters.btn.clear') }}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{ $t('filters.btn.apply') }}</b-button>
      </template>
    </page-card>

    <page-card>
      <template v-slot:header>
        {{ $t('page.list') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="pagination-wrapper">
            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div> <!-- #pagination-wrapper-->

          <div class="table-responsive">
            <b-table striped show-empty
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined

                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">

              <template #cell(id)="data">
                <div>{{data.value | shortId}}</div>
              </template>

              <template #cell(lastTriggered)="data">
                <div>{{data.value | dateFormat('YYYY-MM-DD HH:mm:ss')}}</div>
              </template>

              <template #cell(ruleTypes)="data">
                  <div v-for="rule in data.value.split(',')" :key="rule">
                    {{ $t(`btn.segment.segment_type.${rule}`) }}
                  </div>
              </template>

              <template #cell(isStatic)="data">
                <div>
                  {{ data.item.isStatic ? $t('page.segment.is_static') : $t('page.segment.is_dynamic') }}</div>
              </template>

              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button variant="success" size="sm" @click="openModal('edit', data.item)">
                    {{ $t('table.btn.edit') }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="showItem(data.item)">
                    {{ $t('table.btn.show') }}
                  </b-button>
                  <b-button  variant="primary" size="sm" @click="showSegmentPlayers(data.item)">
                    {{ $t('table.btn.segment.show_players') }}
                  </b-button>
                  <b-button variant="danger" size="sm"
                            v-if="data.item.status != 30"
                            @click="deleteItem(data.item)">
                    {{ $t('table.btn.delete') }}
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{ $t('state.loading') }}</strong>
                </div>
              </template>

            </b-table>
          </div> <!-- #table-responsive-->

          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>
        </div>
      </template>
      <template v-slot:footer>
      </template>
    </page-card>
  </div>

</template>

<script>
import FilterInput from "../../../components/grid/filters/FilterInput";
import FilterSelect from "../../../components/grid/filters/FilterSelect";
import CreateModal from "../components/CreateModal";
import EditModal from "../components/EditModal";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../components/page/PageHeader";
import PageCard from "../../../components/page/PageCard";
import ShowSegmentModal from "../components/ShowSegmentModal";
import Vue from "vue";

export default {
  props: ['apiKey'],
  components: {
    PageCard,
    PageHeader,
    FilterSelect,
    FilterInput,
    GridPagination,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      filterQuery: [],
      orderColumn: 'createdAt',
      orderDirection: false,
      fields: [
        {key: 'id', label: this.$t('table.header.segment.id')},
        {key: 'name', label: this.$t('table.header.segment.name'), sortable: true},
        {key: 'ruleTypes', label: this.$t('table.header.segment.ruleTypes'), sortable: true},
        {key: 'isStatic', label: this.$t('table.header.segment.isStatic'), sortable: true},
        {key: 'lastTriggered', label: this.$t('table.header.segment.lastTriggered'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions')}
      ],
      selectOptions: {
        isStatic: [
          {value: 1, text: this.$t('option.segment.static')},
          {value: 0, text: this.$t('option.segment.dynamic')},
        ]
      },
      showModalInstance: null
    };
  },
  computed: {
    filters: function () {
      return this.$store.getters["root/filter"]('players');
    },
    isBusy: function () {
      return this.$store.getters["userSegment/isBusy"];
    },
    items: function () {
      return this.$store.getters["userSegment/items"];
    },
    totalCount: function () {
      return this.$store.getters["userSegment/totalCount"];
    },
  },
  mounted() {
    if (this.$route.params && this.$route.params.openCreateSegmentModal) {
      this.openModal('create');
    }

    this.loadItems();

    this.$on('refreshGrid', () => {
      this.applyFilters();
    })
  },
  methods: {
    loadItems() {
      this.$store.dispatch('userSegment/loadItems', {
        params: {
          offset: this.perPage * (this.currentPage - 1),
          limit: this.perPage
        },
        filters: this.filterQuery,
        sort: this.createSortQuery()
      });
    },
    paginationReload(data) {
      this.currentPage = data.currentPage;
      this.perPage = data.perPage;
      this.loadItems();
    },
    showSegmentPlayers(segment) {
      const segmentId = segment.id;
      const segmentName = segment.name;

      this.$router.push({ path: `user-segment-players/${segmentId}?segmentName=${segmentName}`});
    },
    createSortQuery() {
      let sorting;
      if (this.orderColumn) {
        if (this.orderDirection === true) {
          sorting = encodeURIComponent('+' + this.orderColumn);
        } else {
          sorting = encodeURIComponent('-' + this.orderColumn);
        }
        return '&sort[]=' + sorting;
      }
      return '';
    },
    openModal(type, item) {
      let ModalConstructor;

      switch (type) {
        case('create'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: CreateModal,
            modalName: 'createModal',
            props: {apiKey: this.apiKey}
          });
          break;
        }
        case('edit'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: EditModal,
            modalName: 'editModal',
            props: {apiKey: this.apiKey, item: item}
          });
          break;
        }
        case('show'): {
          if(!this.showModalInstance){
            ModalConstructor = Vue.extend(ShowSegmentModal)
            this.showModalInstance = new ModalConstructor({parent: this});
            this.showModalInstance.$mount();
          } else {
            this.showModalInstance.showModal();
          }
        }
      }
    },
    showItem(data) {
      this.openModal('show');
      this.showModalInstance.setData(data);
    },
    applyFilters: function () {
      this.currentPage = 1;
      this.loadItems();
    },
    resetFilters() {
      this.$root.$emit('resetFilters');
      this.filterQuery = [];
      this.applyFilters();
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm(this.$t('segment.delete.title') + item.name, {
        title: this.$t('segment.delete.are_you_sure'),
        okTitle: this.$t('btn.segment.delete'),
        cancelTitle: this.$t('btn.segment.cancel'),
        okVariant: 'danger',
      })
      .then(value => {
        if (value) {
          this.$store.dispatch('userSegment/deleteSegment', item.id).then(() => {
            this.applyFilters();
          });
        }
      });
    },
  }
}
</script>

